var $j = $j || jQuery.noConflict();
function bq_show_new_thread(){
    $j('#new-thread-box').addClass('active');
    $j('#new-thread-box textarea').focus();
}
function bq_show_reply(comment_id){
    $j('#reply-box-'+comment_id).addClass('active');
    $j('#reply-box-'+comment_id+' textarea').focus();
}

function isNewDesign() {
    if (typeof bq !== 'undefined' && typeof bq.getIsThemeNew === 'function') {
        return !!bq.getIsThemeNew();
    }
    return $j('body').is('.theme-new, .light-theme, .dark-theme');
}

function bq_new_thread(data, url){
    var $field      = $j('#'+data.parentFieldId + ' #new-thread-text');
    var $formGroup  = $field.closest('.form-group');
    var text        = $field.val();
    var button      = $j('.btn', $formGroup);

    if (text.length == 0){
        if (isNewDesign()) {
            $field.next('.alert-inline-danger').remove();
            var alertHtml = '<div class="alert-inline-danger">' +
                                'Comment can not be empty' +
                            '</div>';
            $field.after(alertHtml);
        } else {
            alert('Comment can not be empty');
        }
        return;
    } else if( $formGroup.hasClass('has-error') ) { // validation check
        return;
    }

    bq_lock_comments(null, button, true);

    data.comment = text;
    var type = $j('#'+data.parentFieldId).find('select[name=comment_type]');
    if (type.length) {
        data.comment_type = type.val();
    }
    $j.ajax(url, {
        data: data
    })
        .done(function(response){
            const bqForm = $field.closest('form.bq-form');
            bq_new_comment_reply_after(response, data);
            bqForm.trigger('bq:submit-vote', { plugin: 'comments', allow: true });
        })
        .fail(function(){})
        .always(function(){bq_unlock_comments(null, button, false);});
}
function bq_comment_reply(data, url) {
    var $field = $j('#reply-to-'+data.parent_comment_id);
    var button = $j('#comment-reply-' + data.parent_comment_id).next().find('.btn');
    var text = $j('#reply-to-'+data.parent_comment_id).val();
    if (text.length == 0){
        if (isNewDesign()) {
            $field.next('.alert-inline-danger').remove();
            var alertHtml = '<div class="alert-inline-danger">' +
                                'Reply can not be empty' +
                            '</div>';
            $field.after(alertHtml);
        } else {
            alert('Reply can not be empty');
        }
        return;
    }
    data.comment = text;

    /**
     * data
     *      id int record_id
     *      parent int comment_id
     *      comment text comment text
     */
    bq_lock_comments(data.parent_comment_id, button, true);
    $j.ajax(url, {
        data: data
    })
        .done(function(response){bq_comment_reply_after(response, data.parent_comment_id);})
        .fail(function(){})
        .always(function(){bq_unlock_comments(data.parent_comment_id,  button, false);});
}

function bq_comment_reply_after(response, comment_id){
    $j('#comment-box-'+comment_id).replaceWith(response);
}

function bq_new_comment_reply_after(response, config){
    $j('#'+config.parentFieldId).replaceWith(response);
}

function bq_lock_comments(comment_id, button, state){
    if(comment_id === null){
        $j('.comment-block').addClass('loading');
    }
    else {
        $j('#comment-box-'+comment_id).addClass('loading');
    }
    $j(button).prop('disabled', state);
    if (isNewDesign()) {
        bq_show_comments_wait_modal();
    }
}
function bq_unlock_comments(comment_id, button, state){
    if(comment_id === null){
        $j('.comment-block').removeClass('loading');
    }
    else {
        $j('#comment-box-'+comment_id).removeClass('loading');
    }
    $j(button).prop('disabled', state);
    if (isNewDesign()) {
        bq_hide_comments_wait_modal();
    }
}

function bq_show_comments_wait_modal() {
    if (typeof bq === 'undefined' || !bq.helper || !bq.helper.throwEvent) {
        return;
    }

    if (typeof $j.fn.viewHandler === 'function' && !$j('body').data('bq.viewHandler')) {
        $j('body').viewHandler($j('body').data());
    }

    var loadingMessage = (bq.messages && bq.messages.global && (bq.messages.global.loadingLongWait || bq.messages.global.loadingGeneral))
        ? (bq.messages.global.loadingLongWait || bq.messages.global.loadingGeneral)
        : 'Please wait...';

    bq.helper.throwEvent('bq.viewhandler.progressmessage', $j('body'), {
        message: loadingMessage
    });
}

function bq_hide_comments_wait_modal() {
    if (typeof bq === 'undefined' || !bq.helper || !bq.helper.throwEvent) {
        return;
    }

    bq.helper.throwEvent('bq.viewhandler.stop', $j('body'));
}

function bq_remove_comment_alert($field) {
    if (!isNewDesign()) {
        return;
    }

    if (!$field || !$field.length) {
        return;
    }

    if ($j.trim($field.val()).length === 0) {
        return;
    }

    var $container = $field.closest('.form-group');
    if (!$container.length) {
        $container = $field.parent();
    }

    $container.find('.alert-inline-danger').remove();
}

$j(document).on('input', '#new-thread-text, textarea[id^="reply-to-"], input[id^="reply-to-"]', function () {
    bq_remove_comment_alert($j(this));
});
